import { isSTGEnvironment } from 'utilities/environment';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';

const assetsBasePath = isSTGEnvironment() ? `assets.stg.openbank.com` : `assets.openbank.com`;

export const createIdentificationQRPath = () => {
    const QRCodeByCountry = {
        es: '/web/tests/qr-code-ES.svg',
        nl: '/web/tests/qr-code-NL.svg',
        de: '/web/tests/qr-code-DE.svg',
        pt: '/web/tests/qr-code-PT.svg',
    };

    const QRPath = QRCodeByCountry[getReferenceCodeByCountry()];

    return `https://${assetsBasePath}${QRPath}`;
};

export const createDocumentationQRPath = () => {
    const QRPath = `/web/images/${getReferenceCodeByCountry()?.toUpperCase()}_QR_from_documentation.svg`;

    return `https://${assetsBasePath}${QRPath}`;
};
